angular
  .module('components', [
    'components.callcenter'
  ]);